/* @flow */

import React from 'react'

const links: Array<Object> = [
  {
    txt: 'Front To Back Culture Home',
    url: 'http://www.fronttobackculture.com',
  },
  {
    txt: 'Available Topics',
    url: '/about/topics_available',
  },
  {
    txt: 'Roadmap Topics',
    url: '/about/topics_roadmap',
  },
  {
    txt: 'How to Use',
    url: '/about/how_to_use',
  },
  {
    txt: 'Pricing',
    url: '/about/pricing',
  },
  {
    txt: 'Terms of Service',
    url: '/terms',
  },
  {
    txt: 'Privacy Policy',
    url: '/privacy',
  },
  {
    txt: 'Contact Us',
    url: 'mailto:ftbcAcademy@fronttobackculture.com.sg',
  },
]

const aCx: string = 'clr-white inline-block small'
const hhsCx = 'col pad-r-1 flex-box align-end dir-column m-marg-t-2 m-marg-l-2 hhs'
const hhsACx = 'clr-white relative hhs'

// PreFooter should remain stateless
// although, it technically isn't pure
// but links should never change once pulled in
class Footer extends React.Component {
  render() {
    return (
      <footer
        id='footer'
        className='bg-primary-darker relative row'>
        <div className='container flex-box just-between no-wrap pad-t-3 pad-b-3 footer-container'>
          <ul
            aria-label='FTBC address and phone number'
            className='col d-2 clr-white small footer-left'
            tabIndex={0}
            >
            <li className='marg-b-1' style={{listStyleType: 'none'}}>
              <a href="https://www.fronttobackculture.com/">
                <img
                  alt="Go to Front to Back Culutre website"
                  width="180px"
                  src="/img/FTBCLogoWhite.png"
                />
              </a>
            </li>
            <li style={{listStyleType: 'none'}}><strong>Front To Back Culture Pte Ltd</strong></li>
            <li style={{listStyleType: 'none'}}>24 Lorong Telok #02-01</li>
            <li style={{listStyleType: 'none'}}>Singapore 049036</li>
            <li style={{listStyleType: 'none'}}>+65 98256909</li>
            <li style={{listStyleType: 'none'}}>
              <a
                className={aCx}
                href='https://www.fronttobackculture.com/'>
                Contact Front To Back Culture
              </a>
            </li>
          </ul>
          <nav
            className='d-2 m-marg-t-2'
            aria-label='FTBC links'>
            <ul className='link-columns'>
              {
                links.map((item: Object, i: number) => (
                  <li
                    key={i}
                    className='marg-b-1' style={{listStyleType: 'none'}}>
                    <a
                      className={aCx}
                      rel='noopener noreferrer'
                      target='_blank'
                      href={item.url}>
                      {item.txt}
                    </a>
                  </li>
                ))
              }
            </ul>
          </nav>
          <div className="flex-row dir-column footer-right">
            <p className='small clr-white italic'>
              Some links on this website may direct you to non-FTBC locations. FTBC does not endorse or guarantee the
              integrity of information on these external sites.
            </p>
          </div>
        </div>
      </footer>
    )
  }
}

Footer.displayName = 'components/Footer'
export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx